const map = {
	"./Add-Subdistrict/Subdistrict-adding.tsx": 56634,
	"./Add-Subdistrict/subdistrict-datatable.tsx": 7453,
	"./Add-Subdistrict/subdistrict-search.tsx": 54041,
	"./Add-Subdistrict/subdistrictMain.tsx": 35721,
	"./Area&PincodeMasterData/addAreaPincode-modal.tsx": 41613,
	"./Area&PincodeMasterData/areaPincode-datatable.tsx": 41177,
	"./Area&PincodeMasterData/areaPincode-main.tsx": 60546,
	"./Area&PincodeMasterData/areaPincode-search.tsx": 96237,
	"./Assign-CustomerExecutive/Assign-Executive-Search.tsx": 89677,
	"./Assign-CustomerExecutive/Assign-Executive-datatable.tsx": 74233,
	"./Assign-CustomerExecutive/Assign-Executive-main.tsx": 12994,
	"./CSE-TargetMapping/CEtargetMapping-datatable.tsx": 38779,
	"./CSE-TargetMapping/CEtargetMapping-main.tsx": 49408,
	"./City/city.tsx": 12264,
	"./City/cityDataTable.tsx": 38310,
	"./City/citySearch.tsx": 86220,
	"./ComplainstList/Complaint-Search.tsx": 1034,
	"./ComplainstList/ComplaintInvoice.tsx": 87134,
	"./ComplainstList/ComplaintList-Details.tsx": 74602,
	"./ComplainstList/View-All-Complaints-datatable.tsx": 59511,
	"./Complaint-Category/categories-datatable.tsx": 9661,
	"./Complaint-Category/categories-details.tsx": 82019,
	"./Complaint-Category/category-search.tsx": 76793,
	"./Complaint/AllComplaintDataTable.tsx": 85515,
	"./Complaint/ComplaintActionDataTable.tsx": 98688,
	"./Complaint/ComplaintActionMain.tsx": 64933,
	"./Complaint/ComplaintActionSearch.tsx": 63106,
	"./Complaint/ComplaintActions.tsx": 16383,
	"./Complaint/ComplaintDatatable.tsx": 41426,
	"./Complaint/ComplaintMain.tsx": 83339,
	"./Complaint/ComplaintRegister.tsx": 55699,
	"./Complaint/ComplaintSearch.tsx": 48848,
	"./Complaint/CustomerComplaintDataTable.tsx": 7234,
	"./Complaint/CustomerComplaintMain.tsx": 94939,
	"./Complaint/CustomerComplaintSearch.tsx": 13792,
	"./Complaint/CustomerProdComplaintRegister.tsx": 93922,
	"./Complaint/CustomerServComplaintRegister.tsx": 68375,
	"./Complaint/InternalComplaint.tsx": 78081,
	"./Complaint/UpdateComplaintDataTable.tsx": 35029,
	"./Complaint/UpdateCustProductComplaintDataTable.tsx": 77145,
	"./Complaint/UpdateCustServiceComplaintDataTable.tsx": 54257,
	"./Complaint/UpdateProductComplaintDataTable.tsx": 17962,
	"./Complaint/UpdateServiceComplaintDataTable.tsx": 44722,
	"./ComplaintInternal/InternalComplaintActionDataTable.tsx": 59962,
	"./ComplaintInternal/InternalComplaintActionMain.tsx": 43171,
	"./ComplaintInternal/InternalComplaintActionRegister.tsx": 50443,
	"./ComplaintInternal/InternalComplaintActionSearch.tsx": 87592,
	"./ComplaintInternal/InternalComplaintDataTable.tsx": 24376,
	"./ComplaintInternal/InternalComplaintMain.tsx": 70413,
	"./ComplaintInternal/InternalComplaintRegister.tsx": 16921,
	"./ComplaintInternal/InternalComplaintSearch.tsx": 18954,
	"./ComplaintInternal/UpdateInternalComplaintDataTable.tsx": 61567,
	"./ComplaintType/Complaint-type-search.tsx": 11266,
	"./ComplaintType/complaint-type-datatable.tsx": 8160,
	"./ComplaintType/type-details.tsx": 93030,
	"./Country/country.tsx": 73952,
	"./Country/countryDataTable.tsx": 29534,
	"./Country/countrySearch.tsx": 1300,
	"./Customer-report/Customer-datatable.tsx": 4268,
	"./Customer-report/Customer-report-export.tsx": 8301,
	"./Customer-report/Customer-report-main.tsx": 19100,
	"./CustomerExecutive-Performance-Report1/CEPerformance-report1-main.tsx": 7503,
	"./CustomerExecutive-Performance-Report1/CustomerExecutive-DailyAcitivity-repot.tsx": 29132,
	"./CustomerExecutive-Performance-Report1/CustomerExecutive-unassignedmapping.tsx": 24971,
	"./CustomerExecutive-Performance-Report1/OrderDetailsPopUp.tsx": 38283,
	"./CustomerexecutiveSalesReport/CESalesReport.tsx": 96390,
	"./CustomerexecutiveSalesReport/InvoicedBySales.tsx": 6312,
	"./DeliveryAddress/OrderSearch.tsx": 24140,
	"./DeliveryAssessmentPlanning/DeliveryAssessmentPlanning.tsx": 85029,
	"./DeliveryExecutiveperformance/DeliveryExecutivePerformance-main.tsx": 6622,
	"./DeliveryExecutiveperformance/PerformanceComponents.tsx": 41730,
	"./Driver-DeliveryDetails/CustomerDelieryReport.tsx": 73011,
	"./Driver-DeliveryDetails/DeliveryAnalysis-Excel.tsx": 37783,
	"./Driver-DeliveryDetails/DeliveryAnalysis-list.tsx": 42316,
	"./Driver-DeliveryDetails/DeliveryAnanlysis-Datatable.tsx": 67276,
	"./Driver-DeliveryDetails/DeliveryChallanPDF.tsx": 39796,
	"./Driver-DeliveryDetails/DeliveryDetailsDatatable.tsx": 45853,
	"./Driver-DeliveryDetails/EWayBill.tsx": 41870,
	"./Driver-DeliveryDetails/ProductSummary.tsx": 93284,
	"./GSTSalesReport/gst-sales-report-datatabel.tsx": 76523,
	"./GSTSalesReport/gst-sales-report-export.tsx": 22683,
	"./GSTSalesReport/gst-sales-report-list.tsx": 49549,
	"./GSTSalesReport/gst-sales-report-search.tsx": 79761,
	"./Generate-Product-code/generate-product-code.tsx": 69832,
	"./GeoMap/BigDrawingControls.tsx": 96325,
	"./GeoMap/DriverPicker.tsx": 73155,
	"./GeoMap/ExportOrdersExcel.tsx": 71573,
	"./GeoMap/ExportRoutesExcel.tsx": 69278,
	"./GeoMap/GoogleMapComponent.tsx": 11693,
	"./GeoMap/GoogleMapPage.tsx": 18595,
	"./GeoMap/Icons.tsx": 10889,
	"./GeoMap/InfoPopup.tsx": 65249,
	"./GeoMap/OptimizedRoutesPanel.tsx": 31850,
	"./GeoMap/OrderListPanel.tsx": 28633,
	"./GeoMap/PolygonManager.tsx": 62624,
	"./GeoMap/PolygonSelectionPanel.tsx": 96577,
	"./GeoMap/PreChallanExportButton.tsx": 31347,
	"./GeoMap/RouteEndpointEditor.tsx": 38680,
	"./GeoMap/RoutePreviewDialog.tsx": 32906,
	"./GeoMap/RoutePreviewMap.tsx": 32166,
	"./GeoMap/SmartMapDock.tsx": 59149,
	"./GeoMap/SmartMapPlanning.tsx": 45803,
	"./GeoMap/VehiclePicker.tsx": 51717,
	"./GeoMap/route-order-popup.tsx": 4758,
	"./GeoMapSearch/DriverSummaryPanel.tsx": 52255,
	"./GeoMapSearch/OrderSearchById.tsx": 34443,
	"./GeoMapSearch/OrdersDialog.tsx": 888,
	"./GeoMapSearch/OrdersLayer.tsx": 50885,
	"./GrnReports/GrnReportsDatatable.tsx": 30164,
	"./GrnReports/GrnReportsMain.tsx": 12569,
	"./GrnReports/GrnReportsSearch.tsx": 50910,
	"./New-Complaint/ComplaintEditDialog.tsx": 33133,
	"./New-Complaint/ComplaintQuickViewDialog.tsx": 24291,
	"./New-Complaint/ComplaintSummaryDataTable.tsx": 71641,
	"./New-Complaint/ComplaintSummaryMain.tsx": 14402,
	"./New-Complaint/ComplaintSummarySearch.tsx": 24301,
	"./New-Complaint/CustomerserviceComplaintregister.tsx": 17711,
	"./New-Complaint/MyComplaints.tsx": 92864,
	"./New-Complaint/ProductComplaintDialog.tsx": 57464,
	"./New-Complaint/RegisterComplaintDialog.tsx": 37684,
	"./New-Generate-Invoice/new-add-product.tsx": 96882,
	"./New-Generate-Invoice/new-create-invoice-items.tsx": 41792,
	"./New-Generate-Invoice/new-create-invoice-top.tsx": 47773,
	"./New-Generate-Invoice/new-create-invoice-total.tsx": 60306,
	"./New-Generate-Invoice/new-create-invoice.tsx": 16291,
	"./New-Generate-Invoice/new-generate-invoice-datatable.tsx": 60633,
	"./New-Generate-Invoice/new-generate-invoice-list.tsx": 15969,
	"./New-Generate-Invoice/new-generate-invoice-search.tsx": 21997,
	"./New-Generate-Invoice/new-invoice-payment.tsx": 9725,
	"./New-Generate-Invoice/new-item-delete-dialog.tsx": 55745,
	"./New-Invoice-Report/new-order-list-datatable.tsx": 91258,
	"./New-Invoice-Report/new-order-list-export.tsx": 22214,
	"./New-Invoice-Report/new-order-list-search.tsx": 54952,
	"./New-Invoice-Report/new-order-list.tsx": 2689,
	"./New-Invoice-Report/new-order-print.tsx": 68488,
	"./New-Invoice-Report/new-order-review-delivery-address.tsx": 95375,
	"./New-Invoice-Report/new-order-review-delivery-details.tsx": 85729,
	"./New-Invoice-Report/new-order-review-delivery-status.tsx": 17861,
	"./New-Invoice-Report/new-order-review-items.tsx": 32814,
	"./New-Invoice-Report/new-order-review-top.tsx": 9179,
	"./New-Invoice-Report/new-order-review-total.tsx": 52800,
	"./New-Invoice-Report/new-order-review.tsx": 31013,
	"./New-Invoice-Report/order-delivery-assignment-dialog.tsx": 78925,
	"./New-Invoice-Report/order-payment-link-button.tsx": 34148,
	"./New-Invoice/new-invoice-data-lists.tsx": 79471,
	"./New-Invoice/new-invoice-details.tsx": 63013,
	"./New-Invoice/new-invoice-items.tsx": 49527,
	"./NewCountry/NewCountry/AddNewCountry.tsx": 56178,
	"./NewCountry/NewCountry/Country-datatable.tsx": 97558,
	"./NewCountry/NewCountry/CountrySearch.tsx": 31261,
	"./NewCountry/NewCountry/Countrydis.tsx": 985,
	"./OrderInvoiceReport/OrderInvoiceReport.tsx": 7590,
	"./Outward-Challan/OutwardChallan-Datatable.tsx": 35418,
	"./Outward-Challan/OutwardChallan-PDF.tsx": 43660,
	"./Outward-Challan/OutwardChallan-main.tsx": 89923,
	"./Outward-Challan/OutwardChallan-search.tsx": 69192,
	"./Outward-Challan/POSEWayBill.tsx": 61785,
	"./POS/AddProductpos.tsx": 71470,
	"./POS/Adjust-product.tsx": 20131,
	"./POS/Inward-product.tsx": 30725,
	"./POS/POS-Inventory-Report.tsx": 15376,
	"./POS/POS-InventoryExcel.tsx": 47782,
	"./POS/Pos-items.tsx": 65227,
	"./POS/Pos-search.tsx": 22923,
	"./POS/incomingRequestDialog.tsx": 70381,
	"./POS/outward-product.tsx": 48010,
	"./POS/pos-list-datatable.tsx": 27756,
	"./POS/request-product.tsx": 79847,
	"./Packing-Orders/packing-order-review-items.tsx": 24185,
	"./Packing-Orders/packing-order-review-top.tsx": 18384,
	"./Packing-Orders/packing-order-review.tsx": 82170,
	"./Packing-Orders/packing-orders.tsx": 32984,
	"./PosMovements/pos-log-datatable.tsx": 85284,
	"./PosMovements/pos-movement-main.tsx": 80850,
	"./PosMovements/pos-movement-search.tsx": 65213,
	"./PosMovements/pos-movement-summary-indetaildatatable.tsx": 16472,
	"./PosMovements/pos-movement-summary-salesindetaildatatable.tsx": 89266,
	"./PosMovements/pos-summary-datatable.tsx": 34946,
	"./ProductRewardRate/ProductRewardRateMain.tsx": 73507,
	"./RM_OutwardChallan/RM-EWayBill.tsx": 22794,
	"./RM_OutwardChallan/RMOutwardChallan-Datatable.tsx": 83750,
	"./RM_OutwardChallan/RMOutwardChallanPage.tsx": 13020,
	"./Raw-Materials-Inventory/Adjust-rawMaterials.tsx": 64246,
	"./Raw-Materials-Inventory/Incoming-RawMaterial-Request.tsx": 58264,
	"./Raw-Materials-Inventory/Inward-RawMaterial-Request.tsx": 83431,
	"./Raw-Materials-Inventory/Outward-RawMaterial-Request.tsx": 26088,
	"./Raw-Materials-Inventory/Outward-RawMaterials.tsx": 20937,
	"./Raw-Materials-Inventory/Request-rawMaterials.tsx": 46214,
	"./Raw-Materials-Inventory/add-rawMaterial-pos.tsx": 39282,
	"./Raw-Materials-Inventory/raw-material-datatable.tsx": 48489,
	"./Raw-Materials-Inventory/raw-material-main.tsx": 2994,
	"./Raw-Materials-Inventory/raw-material-search.tsx": 93309,
	"./RawMaterial-Movements/RawMaterial-movement-log.tsx": 36974,
	"./RawMaterial-Movements/RawMaterial-movement-main.tsx": 92369,
	"./RawMaterial-Movements/RawMaterial-movement-summary.tsx": 35756,
	"./RawMaterial-Movements/RawMaterialExportMovementLog.tsx": 61268,
	"./RawMaterial-Movements/RawMaterialExportSummary.tsx": 38503,
	"./RawMaterial-Movements/rawMaterial-movement-search.tsx": 92214,
	"./RawMaterials/RawMaterial-Categories/RawMaterialCategories-Search.tsx": 84703,
	"./RawMaterials/RawMaterial-Categories/RawMaterialCategory-Datatable.tsx": 907,
	"./RawMaterials/RawMaterial-Categories/RawMaterialCategory-Main.tsx": 17072,
	"./RawMaterials/RawMaterial-Search.tsx": 71116,
	"./RawMaterials/RawMaterial-main.tsx": 24559,
	"./RawMaterials/RawMaterialDatatable.tsx": 56569,
	"./RawMaterials/RawMaterialHistory-Datatable.tsx": 65550,
	"./RawMaterials/RawMaterialHistory-Export.tsx": 30370,
	"./RawMaterials/RawMaterialHistory-Main.tsx": 4935,
	"./RawMaterials/RawMaterialHistory-Search.tsx": 11940,
	"./RawMaterials/RawMaterialPurchaseExport.tsx": 91238,
	"./RawMaterials/RawMaterialPurchaseMain.tsx": 23299,
	"./RawMaterials/RawMaterialPurchaseViewTable.tsx": 8207,
	"./RawMaterials/RawMaterialQualityCheck.tsx": 56756,
	"./RawMaterials/RawMaterials-List/RawMaterial-Main.tsx": 38583,
	"./RawMaterials/RawMaterials-List/RawMaterial-Search.tsx": 6420,
	"./RawMaterials/RawMaterials-List/RawMaterialList-Datatable.tsx": 43058,
	"./RawMaterials/RawMaterialspurchase.tsx": 16835,
	"./RawMaterials/RawMaterialspurchase1.tsx": 99486,
	"./RawMaterials/inventory-summary/RawMaterial-Export.tsx": 71348,
	"./RawMaterials/inventory-summary/RawMaterial-Report.tsx": 88304,
	"./Role-assignment/RoleAccessSearch.tsx": 11890,
	"./Role-assignment/RoleAccessdatatable.tsx": 86352,
	"./Role-assignment/RoleAccessmain.tsx": 4085,
	"./RoleCreation/RoleCreation-main.tsx": 62028,
	"./SalesProductionReport/sales-production-report.tsx": 36876,
	"./SubCategory/subCategory.tsx": 65376,
	"./SubCategory/subCategoryDatatable.tsx": 93694,
	"./SubCategory/subCategorySearch.tsx": 27764,
	"./SwipeMachine-UserAccess/UserSwipeMachineAccess.tsx": 84695,
	"./SwipeMachine-UserAccess/userSwipeMachineDialog.tsx": 82041,
	"./TestReport/PublicTestReport.tsx": 11909,
	"./TestReport/ReportTabsDialog.tsx": 37258,
	"./TestReport/SampleReportPdf.tsx": 99872,
	"./TestReport/TestReportGenerate.tsx": 64055,
	"./TestReport/TestReportPdf.tsx": 16064,
	"./TestReport/TestReportSearch.tsx": 28854,
	"./TestReport/TestReportsDatatable.tsx": 16935,
	"./TestReport/TestReportsPage.tsx": 82550,
	"./Traceability/Traceability.tsx": 12826,
	"./UserSubscriptions/NewUserSubscriptionsModal.tsx": 10059,
	"./UserSubscriptions/SubscriptionProductModal.tsx": 53814,
	"./UserSubscriptions/UserSubscriptionsCard.tsx": 41038,
	"./UserSubscriptions/UserSubscriptionsPage.tsx": 27217,
	"./UserTrafficSourceAudit/UserTrafficSourceAuditAddDialog.tsx": 10097,
	"./UserTrafficSourceAudit/UserTrafficSourceAuditDataTable.tsx": 99816,
	"./UserTrafficSourceAudit/UserTrafficSourceAuditMain.tsx": 13693,
	"./UserTrafficSourceAudit/UserTrafficSourceAuditSearch.tsx": 1338,
	"./Vehicle-Details/Add-Vehicle.tsx": 9823,
	"./Vehicle-Details/Vehicle-List.tsx": 72916,
	"./Vendor/AddVendor.tsx": 23097,
	"./Vendor/VendorDataTable.tsx": 57684,
	"./View-All-Challan/EWayForm.tsx": 2925,
	"./View-All-Challan/View-Challan-Details.tsx": 1675,
	"./View-All-Challan/View-Challan-PDF.tsx": 18363,
	"./View-All-Challan/ViewAllChallan-Datatable.tsx": 98545,
	"./View-Bin_orders/bin-details.tsx": 89303,
	"./View-Bin_orders/view-bin.tsx": 64418,
	"./add-area/add-areaPincode.tsx": 31260,
	"./add-area/add-country.tsx": 60169,
	"./add-area/area-datatable.tsx": 31661,
	"./add-area/area-search.tsx": 45289,
	"./add-area/areaPincode.tsx": 54994,
	"./add-state/state-adding.tsx": 88766,
	"./add-state/state-datatable.tsx": 39425,
	"./add-state/state-search.tsx": 37541,
	"./add-state/stateMain.tsx": 94669,
	"./admin/AddArea.tsx": 62531,
	"./admin/AddAreaPincodeMaster.tsx": 28991,
	"./admin/AddCountry.tsx": 95116,
	"./admin/AddDistrict.tsx": 59558,
	"./admin/AddState.tsx": 73961,
	"./admin/AddSubdistrict.tsx": 90630,
	"./admin/AddUser.tsx": 76701,
	"./admin/product-info.tsx": 55931,
	"./admin/product-search.tsx": 987,
	"./admin/view-all-products-datatable.tsx": 2232,
	"./admin/view-all-products.tsx": 47587,
	"./app-loading/app-loading.tsx": 41156,
	"./banners/BannerCarousel.tsx": 43473,
	"./banners/banner.tsx": 99515,
	"./banners/flash-news-modal.tsx": 24775,
	"./basket/cart-tems.tsx": 12328,
	"./basket/carts.tsx": 1895,
	"./basket/item-delete-dialog.tsx": 76572,
	"./basket/items-summary.tsx": 49401,
	"./basket/user-dropdown-select.tsx": 26210,
	"./billing-order-details/billing-order-details.tsx": 47670,
	"./billing-order-details/billing-receipt-router.tsx": 45639,
	"./billing-order-details/order-receipt.tsx": 21046,
	"./bread-crumb/bread-crumb.tsx": 34236,
	"./canceledOrder/canceled-order-datatable.tsx": 22126,
	"./canceledOrder/canceled-order-export.tsx": 45410,
	"./canceledOrder/canceled-order-main.tsx": 30247,
	"./canceledOrder/canceled-order-search.tsx": 63972,
	"./cash-collection-report/cash-collection-report-dataTabel.tsx": 14921,
	"./cash-collection-report/cash-collection-report-list.tsx": 54511,
	"./cash-collection-report/cash-collection-report-search.tsx": 86979,
	"./cash-report-detail/cash-Datatable.tsx": 97774,
	"./category/category.tsx": 41865,
	"./category/categoryDataTable.tsx": 10388,
	"./category/categorySearch.tsx": 15358,
	"./common/ImageCropper.tsx": 69321,
	"./courier-charges/courier-charges-delete.tsx": 48258,
	"./courier-charges/courier-charges-dialog.tsx": 271,
	"./courier-charges/courier-charges-table.tsx": 54427,
	"./courier-charges/courier-charges-toolbar.tsx": 74202,
	"./courier-charges/courier-charges.tsx": 84679,
	"./courier-details/courier-details.tsx": 41936,
	"./courier-provider/courier-provider-list.tsx": 75879,
	"./courier-provider/courier-provider-new.tsx": 98321,
	"./courier-provider/courier-provider.tsx": 71576,
	"./courier-provider/courier-tin-criteria.tsx": 74106,
	"./courier-provider/courier-vassel-bottols-criteria.tsx": 61527,
	"./customer-FollowUP/CustomerFollowUp-main.tsx": 74631,
	"./customer-FollowUP/customer-followup-datatable.tsx": 38299,
	"./customer-FollowUP/customer-followup-search.tsx": 99427,
	"./customer-analytics/churn/churn-datatable.tsx": 3701,
	"./customer-analytics/churn/churn-search.tsx": 13633,
	"./customer-analytics/customer-analytics-main.tsx": 47603,
	"./customer-analytics/pareto/pareto-datatable.tsx": 64477,
	"./customer-analytics/pareto/pareto-search.tsx": 12089,
	"./customer-analytics/rfm/rfm-datatable.tsx": 18877,
	"./customer-analytics/rfm/rfm-search.tsx": 3065,
	"./customer-analytics/shared/call-status-cell.tsx": 59305,
	"./dashboards/RawMaterialStockDashboard.tsx": 50740,
	"./dashboards/TradingStockDashboard.tsx": 68030,
	"./dashboards/WipProductionMain.tsx": 61185,
	"./dashboards/open-order-payment-breakdown.tsx": 73651,
	"./dashboards/performanceDashboard.tsx": 95981,
	"./delivery-AccCash-collection/aacounts-cash-search.tsx": 90503,
	"./delivery-AccCash-collection/accounts-cash-datatable.tsx": 99169,
	"./delivery-AccCash-collection/accounts-cash-main.tsx": 21722,
	"./delivery-cash/cash-handover-dialog.tsx": 26766,
	"./delivery-cash/delivery-cash-datatable.tsx": 19707,
	"./delivery-cash/delivery-cash-main.tsx": 93952,
	"./delivery-cash/delivery-cash-search.tsx": 64483,
	"./delivery-cash/handover-history-dialog.tsx": 36547,
	"./delivery-storecash-collection/CombinedCashTraceDialog.tsx": 66629,
	"./delivery-storecash-collection/incomingCashRequestDialog.tsx": 85618,
	"./delivery-storecash-collection/store-cash-handover-dialog.tsx": 63940,
	"./delivery-storecash-collection/storecash-datatable.tsx": 80875,
	"./delivery-storecash-collection/storecash-main.tsx": 59952,
	"./delivery-storecash-collection/storecash-search.tsx": 89491,
	"./delivery-work/DeliveryJourney.tsx": 574,
	"./delivery-work/DeliveryLocationPanel.tsx": 98719,
	"./delivery-work/DeliveryPerformanceDashboard.tsx": 1552,
	"./delivery-work/DeliveryWorkControls.tsx": 71025,
	"./delivery-work/DeliveryWorkReport.tsx": 99561,
	"./desiriBulls/DesiriBullsPage.tsx": 83585,
	"./desiriBulls/desiri-bulls-search.tsx": 3180,
	"./desiriBulls/desiri-bulls-table.tsx": 73878,
	"./desiriGaana/DesiriGaanaPage.tsx": 55981,
	"./desiriGaana/desiri-gaana-search.tsx": 18316,
	"./desiriGaana/desiri-gaana-table.tsx": 15606,
	"./desiriRoles/DesiriRolesPage.tsx": 97489,
	"./desiriRoles/desiri-roles-search.tsx": 92690,
	"./desiriRoles/desiri-roles-table.tsx": 83608,
	"./desiriUsers/DesiriUserPage.tsx": 13458,
	"./desiriUsers/desiri-user-search.tsx": 16411,
	"./desiriUsers/desiri-user-table.tsx": 94315,
	"./districtmaster/district-add.tsx": 1066,
	"./districtmaster/district-datatable.tsx": 22875,
	"./districtmaster/district-search.tsx": 16163,
	"./districtmaster/districtMain.tsx": 56599,
	"./edit-address/edit-address-datatable.tsx": 17035,
	"./edit-address/edit-address-delete.tsx": 54442,
	"./edit-address/edit-address-search.tsx": 14707,
	"./edit-address/edit-cust-address.tsx": 40364,
	"./edit-users/edit-users.tsx": 18064,
	"./edit-users/user-delete-dialog.tsx": 87331,
	"./edit-users/users-datatable.tsx": 91792,
	"./edit-users/users-search.tsx": 84274,
	"./empty-layout/empty.tsx": 76685,
	"./file-action/file-action-controls.tsx": 84645,
	"./forget-password/forget-password.tsx": 1996,
	"./images/file-upload-template.tsx": 10631,
	"./invoice/invoice-data-lists.tsx": 13995,
	"./invoice/invoice-details.tsx": 60049,
	"./invoice/invoice-items.tsx": 74379,
	"./invoices/create-inv-items.tsx": 98419,
	"./invoices/create-inv-top.tsx": 69234,
	"./invoices/create-inv-total.tsx": 18933,
	"./invoices/create-invoice.tsx": 59232,
	"./invoices/generate-inv.tsx": 54081,
	"./invoices/invoice-payment.tsx": 51336,
	"./invoices/invoice-payment2.tsx": 26480,
	"./invoices/invoices-datatable.tsx": 99927,
	"./invoices/invoices-search.tsx": 14121,
	"./invoices/item-delete-dialog.tsx": 89142,
	"./invoices/payment-process.tsx": 62830,
	"./invoices/select-payment-invoice.tsx": 58573,
	"./layout/AppConfig.tsx": 23685,
	"./layout/AppFooter.tsx": 73230,
	"./layout/AppMenu.tsx": 57210,
	"./layout/AppMenuitem.tsx": 27699,
	"./layout/AppSidebar.tsx": 10575,
	"./layout/AppTopbar.tsx": 69881,
	"./layout/Breadcrumbs.tsx": 47816,
	"./layout/context/layoutcontext.tsx": 13757,
	"./layout/context/menucontext.tsx": 54420,
	"./layout/footer-notes/about-us.tsx": 7122,
	"./layout/footer-notes/contact-us.tsx": 21943,
	"./layout/footer-notes/privacy-policy.tsx": 68249,
	"./layout/footer-notes/return-policy.tsx": 63589,
	"./layout/footer-notes/shipping-policy.tsx": 90073,
	"./layout/footer-notes/terms-and-conditions-register.tsx": 39338,
	"./layout/footer-notes/terms-conditions.tsx": 25838,
	"./layout/layout.tsx": 33894,
	"./map/google-map.tsx": 96964,
	"./measurements/measurement-delete-confirmation.tsx": 67905,
	"./measurements/measurement-dialog.tsx": 33050,
	"./measurements/measurement-table.tsx": 33964,
	"./measurements/measurement-toolbar.tsx": 25449,
	"./measurements/measurement.tsx": 8747,
	"./my-order/my-order-datatable.tsx": 82115,
	"./my-order/my-order.tsx": 19048,
	"./new-sidebar-cart/sidecart-address.tsx": 1658,
	"./new-sidebar-cart/sidecart-courier.tsx": 69707,
	"./new-sidebar-cart/sidecart-items.tsx": 20910,
	"./new-sidebar-cart/sidecart-main.tsx": 94471,
	"./new-sidebar-cart/sidecart-payment.tsx": 90508,
	"./new-sidebar-cart/sidecart-summary.tsx": 15482,
	"./news/add-news-modal.tsx": 53122,
	"./news/news-datatable.tsx": 43507,
	"./news/news-modal.tsx": 11124,
	"./news/sticky-flash-news-button.tsx": 69076,
	"./not-found/not-found.tsx": 3392,
	"./oilProduction/EditProductionaLogDialog.tsx": 75069,
	"./oilProduction/OilProductionDataTable.tsx": 14374,
	"./oilProduction/OilProductionDataTable1.tsx": 55893,
	"./oilProduction/OilProductionDataTable2.tsx": 9606,
	"./oilProduction/OilProductionLogs.tsx": 51385,
	"./oilProduction/OilProductionLogs1.tsx": 46936,
	"./oilProduction/OilProductionLogs1DT2.tsx": 91120,
	"./oilProduction/OilProductionRecords.tsx": 61600,
	"./oilProduction/OilProductionSearch.tsx": 37420,
	"./oilProduction/OilProductionSearchDatatable2.tsx": 85778,
	"./oilProduction/OilProductionSearchRecords.tsx": 33284,
	"./oilProduction/SeedOilDataTable.tsx": 30854,
	"./oilProduction/StockSummaryDashboard.tsx": 3715,
	"./oilProduction/SummaryReport.tsx": 71319,
	"./oilProduction/bull-statistics/card.tsx": 30067,
	"./oilProduction/bull-statistics/filter.tsx": 23439,
	"./oilProduction/bull-statistics/main.tsx": 84398,
	"./oilProduction/oilProductionLog.tsx": 17964,
	"./oilProduction/oilProductionLog1.tsx": 12383,
	"./oilProduction/oilProductionmain.tsx": 81167,
	"./oilProduction/oilProductionmain1.tsx": 76962,
	"./oilProduction/oilProductiontable.tsx": 73270,
	"./oilProduction/oilProductiontable1.tsx": 25701,
	"./onlinepayment-report-detail/onlinepayment-dataTable.tsx": 48268,
	"./open-courier-orders-report/open-courier-orders-report.tsx": 17272,
	"./openorders-address/OrderTabPanel.tsx": 79869,
	"./openorders-address/open-order.tsx": 145,
	"./orders/delivery-address.tsx": 83584,
	"./orders/delivery-details.tsx": 58630,
	"./orders/delivery-status.tsx": 20524,
	"./orders/order-details-dialog.tsx": 62457,
	"./orders/order-details-top.tsx": 83372,
	"./orders/order-details.tsx": 98926,
	"./orders/order-items.tsx": 34868,
	"./orders/order-list-datatable.tsx": 65277,
	"./orders/order-list-search.tsx": 27385,
	"./orders/order-list.tsx": 22182,
	"./orders/order-print.tsx": 76945,
	"./orders/order-review-delivery-address.tsx": 65614,
	"./orders/order-review-delivery-details.tsx": 7652,
	"./orders/order-review-delivery-status.tsx": 43170,
	"./orders/order-review-items.tsx": 20021,
	"./orders/order-review-top.tsx": 31319,
	"./orders/order-review-total.tsx": 83511,
	"./orders/order-review.tsx": 11014,
	"./orders/order-summary.tsx": 60412,
	"./orders/order-total.tsx": 51454,
	"./orders/orderDeliverySummary.tsx": 47647,
	"./orders/payment-details-dialog.tsx": 95121,
	"./payment-getways/main-getway-request.tsx": 19136,
	"./payment-getways/main-getway-response.tsx": 87594,
	"./payment-getways/payment-iframe.tsx": 44590,
	"./payments/payment-mode.tsx": 83499,
	"./payments/payment.tsx": 93179,
	"./pincode-pos/pincode-pos.tsx": 65031,
	"./pos-products-Stock-Summary/AcceptOutwardRequestDialog.tsx": 45028,
	"./pos-products-Stock-Summary/AddProductStockDialog.tsx": 26229,
	"./pos-products-Stock-Summary/AdjustDialog.tsx": 50284,
	"./pos-products-Stock-Summary/IncomingRequestsDialog.tsx": 76303,
	"./pos-products-Stock-Summary/InwardDialog.tsx": 13970,
	"./pos-products-Stock-Summary/InwardRequestsTab.tsx": 41727,
	"./pos-products-Stock-Summary/OutwardDialog.tsx": 25187,
	"./pos-products-Stock-Summary/OutwardRequestsTab.tsx": 18692,
	"./pos-products-Stock-Summary/PosProductStockSummary.tsx": 7532,
	"./pos-products-Stock-Summary/PosStockSummaryDatatable.tsx": 98817,
	"./pos-products-Stock-Summary/PosStockSummarySearch.tsx": 31441,
	"./pos-products-Stock-Summary/RequestDialog.tsx": 40142,
	"./pos-products-Stock-Summary/RequestStatusDialog.tsx": 3748,
	"./pos-products-Stock-Summary/ViewBatchesDialog.tsx": 98956,
	"./pos-repot-details/pos-report-treemap-template.tsx": 79734,
	"./pos-repot-details/pos-repot-list.tsx": 85904,
	"./pos_TargetMapping/pos-target-mapping-datatable.tsx": 88212,
	"./pos_TargetMapping/pos-target-mapping-list.tsx": 99406,
	"./product/single-product-details.tsx": 27902,
	"./productbatch/ProductBatchDataTable.tsx": 84438,
	"./productbatch/ProductBatchDialog.tsx": 62900,
	"./productbatch/ProductBatchSummary.tsx": 35106,
	"./productbatch/ProductBatchVisibilityDialog.tsx": 6364,
	"./productbatchexpire/ProductBatchExpireDataTable.tsx": 53868,
	"./productbatchexpire/ProductBatchExpireHeader.tsx": 84417,
	"./productbatchexpire/ProductBatchExpireSearch.tsx": 88070,
	"./products/Add-product-inv.tsx": 12357,
	"./products/category-left-view-new.tsx": 88623,
	"./products/category-left-view.tsx": 14854,
	"./products/category-mobile-dropdown.tsx": 49037,
	"./products/category-top-lists.tsx": 60180,
	"./products/category-top-view.tsx": 1860,
	"./products/product-notify-dialog.tsx": 66098,
	"./products/product-quick-view.tsx": 6729,
	"./products/products-card-items.tsx": 57064,
	"./products/products-card.tsx": 85851,
	"./products/products-checkout-dialog.tsx": 27300,
	"./products/products-grid-items.tsx": 58178,
	"./products/products-list-items.tsx": 72814,
	"./products/products-views.tsx": 36371,
	"./products/products.tsx": 99651,
	"./products/selected-categories.tsx": 31524,
	"./profile/password.tsx": 94744,
	"./profile/userprofile.tsx": 13519,
	"./qr/InlineQrScanner.tsx": 1333,
	"./referral/ReferralBanner.tsx": 36930,
	"./referral/ReferralPage.tsx": 8125,
	"./referrals-restriction/referrals-datatable.tsx": 42546,
	"./referrals-restriction/referrals-restriction.tsx": 87932,
	"./referrals-restriction/referrals-search.tsx": 976,
	"./register/referral-logic.tsx": 96989,
	"./register/register.tsx": 35020,
	"./reports/delivery-address.tsx": 76782,
	"./reports/delivery-details.tsx": 66820,
	"./reports/delivery-status.tsx": 1666,
	"./reports/order-details-dialog.tsx": 78283,
	"./reports/order-details-top.tsx": 28238,
	"./reports/order-details.tsx": 38724,
	"./reports/order-items.tsx": 18386,
	"./reports/order-list-datatable.tsx": 52643,
	"./reports/order-list-search.tsx": 17147,
	"./reports/order-list.tsx": 75496,
	"./reports/order-print.tsx": 91275,
	"./reports/order-review-delivery-address.tsx": 16784,
	"./reports/order-review-delivery-details.tsx": 16086,
	"./reports/order-review-delivery-status.tsx": 61660,
	"./reports/order-review-items.tsx": 42763,
	"./reports/order-review-top.tsx": 70202,
	"./reports/order-review-total.tsx": 17645,
	"./reports/order-review.tsx": 62200,
	"./reports/order-summary.tsx": 3230,
	"./reports/order-total.tsx": 73164,
	"./resend-payment-link/resend-payment-link-Datatable.tsx": 60627,
	"./resend-payment-link/resend-payment-link-list.tsx": 20583,
	"./rewards/admin/RewardsAdminDashboard.tsx": 65283,
	"./rewards/details/RewardDetails.tsx": 95730,
	"./rewards/details/TransactionDialog.tsx": 28283,
	"./route-code/assign-route-code.tsx": 63664,
	"./route-code/route-code-datatable.tsx": 54351,
	"./route-code/route-code-search.tsx": 77151,
	"./route-codes/rote-codes.tsx": 61753,
	"./route-codes/route-codeDataTable.tsx": 7115,
	"./route-codes/route-codeSearch.tsx": 78963,
	"./security/auth-guard.tsx": 11302,
	"./security/private-route.tsx": 31215,
	"./setting/setting.tsx": 35608,
	"./shared/ReportPageHeader.tsx": 27855,
	"./signin/signin-component.tsx": 23404,
	"./state/state.tsx": 47652,
	"./state/stateDataTable.tsx": 88322,
	"./state/stateSearch.tsx": 5952,
	"./status-search/status-datatable.tsx": 14286,
	"./status-search/status-details.tsx": 77208,
	"./status-search/status-search.tsx": 78692,
	"./user-address/add-or-edit-address.tsx": 63223,
	"./user-address/address-lists.tsx": 12090,
	"./user-address/address-selector.tsx": 51322,
	"./user-address/addresss.tsx": 65131,
	"./user-address/all-address.tsx": 80808,
	"./user-address/delivery-location.tsx": 48090,
	"./user-address/editonarea.tsx": 94644,
	"./user-address/location-search/get-location.tsx": 50413,
	"./user-address/location-search/search-location.tsx": 86528,
	"./user-menu/menu/menu.tsx": 32010,
	"./user-menu/profile-menu/ProfileMenu.tsx": 59057,
	"./user-preferred-delivery/user-delivery.tsx": 44324,
	"./user-role-assignment/role-assignment-dialog.tsx": 32145,
	"./user-role-assignment/role-assignment-main.tsx": 34102,
	"./user-role-assignment/role-assignment-search.tsx": 19625,
	"./user-role-assignment/role-assignment-table.tsx": 25213,
	"./user-role-creation/role-creation-dialog.tsx": 79829,
	"./user-role-creation/role-creation-main.tsx": 33962,
	"./user-role-creation/role-creation-search.tsx": 94709,
	"./user-role-creation/role-creation-table.tsx": 74513,
	"./user-role-permissions/role-permissions.tsx": 77006,
	"./user-sales-ordering/sales-cart-stock.tsx": 85441,
	"./user-sales-ordering/sales-ordering-address.tsx": 22533,
	"./user-sales-ordering/sales-ordering-customer.tsx": 26082,
	"./user-sales-ordering/sales-ordering-dialog.tsx": 97933,
	"./user-sales-ordering/sales-ordering-main.tsx": 90722,
	"./user-sales-ordering/sales-ordering-payment-mode.tsx": 14831,
	"./user-sales-ordering/sales-ordering-payment.tsx": 47295,
	"./where-is-my-cash-report/CollectedAmountTraceDatatable.tsx": 17070,
	"./where-is-my-cash-report/HandoverAmountTraceDatatable.tsx": 21832,
	"./where-is-my-cash-report/ReceivedAmountTraceDatatable.tsx": 78144,
	"./where-is-my-cash-report/cash-report-datatable.tsx": 41705,
	"./where-is-my-cash-report/cash-report-main.tsx": 16274,
	"./where-is-my-cash-report/cash-report-search.tsx": 89437,
	"./whyNotDelvered/whyNotDeliveredSummary.tsx": 49479,
	"./wish-list/my-wish-list.tsx": 77043
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50124;